import React from 'react';
import { FaFacebook, FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaClock } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Início', href: '#home' },
    { name: 'Serviços', href: '#servicos' },
    { name: 'Sobre Nós', href: '#sobre' },
    { name: 'Depoimentos', href: '#depoimentos' },
    { name: 'Contato', href: '#contato' }
  ];

  const services = [
    'Troca de Óleo',
    'Sistema de Freios',
    'Suspensão',
    'Manutenção Preventiva',
    'Motor',
    'Sistema Elétrico',
    'Injeção Eletrônica',
    'Ar Condicionado'
  ];

  return (
    <footer className="bg-gradient-to-br from-secondary-dark to-black text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div>
            <img 
              src="/assets/logo.png" 
              alt="Mecânica Box 50" 
              className="w-48 mb-4"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{display: 'none'}}>
              <h3 className="text-2xl font-bold mb-2">
                <span className="text-white">MECÂNICA</span>
              </h3>
              <h3 className="text-3xl font-bold mb-4">
                <span className="text-white">BOX</span>
                <span className="text-primary ml-2">50</span>
              </h3>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Há mais de 10 anos cuidando do seu veículo com qualidade, 
              profissionalismo e dedicação. Seu carro em boas mãos.
            </p>
            
            {/* Social Media */}
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/mecanicabox50?locale=pt_BR"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <FaFacebook className="text-xl" />
              </a>
              <a
                href="https://www.instagram.com/mecanica_box_50/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <FaInstagram className="text-xl" />
              </a>
              <a
                href="https://wa.me/5511972918839"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="WhatsApp"
              >
                <FaWhatsapp className="text-xl" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Links Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-primary transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <span className="w-1.5 h-1.5 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Nossos Serviços</h4>
            <ul className="space-y-3">
              {services.slice(0, 5).map((service, index) => (
                <li key={index}>
                  <a
                    href="#servicos"
                    className="text-gray-300 hover:text-accent transition-colors duration-300 flex items-center gap-2 group text-sm"
                  >
                    <span className="w-1.5 h-1.5 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-300">
                <FaMapMarkerAlt className="text-primary mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <p>R. Adelino Marucci, 201</p>
                  <p>Vila Nova - Araçariguama, SP</p>
                </div>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <FaPhone className="text-primary mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <p>(11) 97291-8839</p>
                </div>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <FaClock className="text-primary mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <p>Seg-Sex: 8h-12h, 13h-18h</p>
                  <p>Sáb: 8h-13h</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>
              &copy; {currentYear} Mecânica Box 50. Todos os direitos reservados.
            </p>
            <div className="flex gap-6">
              <a href="#privacidade" className="hover:text-primary transition-colors">
                Política de Privacidade
              </a>
              <a href="#termos" className="hover:text-primary transition-colors">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <a
        href="#home"
        className="fixed bottom-24 right-6 w-12 h-12 bg-primary hover:bg-primary-dark text-secondary-dark rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 z-40"
        aria-label="Voltar ao topo"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </a>
    </footer>
  );
};

export default Footer;
